import { put, takeEvery } from "redux-saga/effects"
import { GET_PAYMENT_DETAIL } from "./actionTypes"

import {
    getPaymentDetailsSuccess,
    getPaymentDetailsFail,
} from "./actions"
import servicePaymentDetail from "../../api/paymentDetail.service"

function* fetchPaymentDetail({ payload: filter }) {
    try {
        const response = yield servicePaymentDetail.getPaymentDetails(filter)
        const error = response?.response?.data?.error
        if (error) {
            yield put(getPaymentDetailsFail(error))
        } else {
            yield put(getPaymentDetailsSuccess(response))
        }
    } catch (error) {
        yield put(getPaymentDetailsFail(error))
    }
}


function* paymentDetailSaga() {
    yield takeEvery(GET_PAYMENT_DETAIL, fetchPaymentDetail)
}
export default paymentDetailSaga